import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: 'easeOut' },
    },
  };

  return (
    <section
      id="hero"
      className="pt-32 pb-20 bg-gradient-to-b from-light to-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center"
        >
          {/* Left Content */}
          <div className="space-y-6">
            <motion.h1
              variants={itemVariants}
              className="text-5xl lg:text-6xl font-bold leading-tight text-dark"
            >
              Innovative Digital Solutions for
              <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                {' '}Modern Businesses
              </span>
            </motion.h1>

            <motion.p
              variants={itemVariants}
              className="text-lg text-gray-600 leading-relaxed max-w-lg"
            >
              We craft custom software solutions and scalable applications tailored to your business needs. From startups to enterprises, we deliver excellence at every step.
            </motion.p>

            <motion.div
              variants={itemVariants}
              className="flex flex-col sm:flex-row gap-4 pt-4"
            >
              <motion.button
                whileHover={{ scale: 1.05, boxShadow: '0 10px 25px rgba(229, 57, 53, 0.3)' }}
                whileTap={{ scale: 0.95 }}
                onClick={() => scrollToSection('contact')}
                className="bg-primary hover:bg-secondary text-white px-8 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center justify-center gap-2"
              >
                Get Started <ArrowRight size={20} />
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.05, borderColor: '#E53935' }}
                whileTap={{ scale: 0.95 }}
                onClick={() => scrollToSection('our-expertise')}
                className="border-2 border-gray-300 text-dark hover:border-primary px-8 py-3 rounded-lg font-semibold transition-all duration-200"
              >
                View Expertise
              </motion.button>
            </motion.div>
          </div>

          {/* Right Illustration */}
          <motion.div
            variants={itemVariants}
            className="hidden lg:flex items-center justify-center"
          >
            <div className="relative w-full h-96">
              {/* Gradient Background Shape */}
              <motion.div
                animate={{
                  y: [0, -20, 0],
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: 'easeInOut',
                }}
                className="absolute inset-0 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-3xl blur-3xl"
              />

              {/* Dashboard Mockup */}
              <motion.div
                animate={{
                  y: [20, 0, 20],
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: 'easeInOut',
                }}
                className="relative bg-white rounded-2xl p-6 shadow-soft-lg border border-gray-100"
              >
                <div className="space-y-4">
                   <img
      src="/assets/img/logo.png"
      alt="logo"
      className="h-14 w-auto object-contain"
    />
                </div>
              </motion.div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
